export default {
  carnet: 'brands.carnet',
  elo: 'brands.elo',
  sodexo: 'brands.sodexo',
  vr: 'brands.vr',
  mais: 'brands.mais',
  hipercard: 'brands.hipercard',
  discover: 'brands.discover',
  paqueta: 'brands.paqueta',
  diners: 'brands.diners',
  amex: 'brands.amex',
  aura: 'brands.aura',
  jcb: 'brands.jcb',
  visa: 'brands.visa',
  mastercard: 'brands.mastercard',
  alelo: 'brands.alelo',
  unionpay: 'brands.unionpay',
  others: 'brands.others',
  casaShow: 'brands.casashow',
  havan: 'brands.havan',
  hugCard: 'brands.hugCard',
  leaderCard: 'brands.leaderCard',
  pernambucanas: 'brands.pernambucanas',
  casaEVideo: 'brands.casaevideo',
  cassol: 'brands.cassol',
  koerich: 'brands.koerich',
  andaraki: 'brands.andaraki',
  submarino: 'brands.submarino',
  credz: 'brands.credz',
  senff: 'brands.senff',
  cabal: 'brands.cabal',
  sorocred: 'brands.sorocred',
  banescard: 'brands.banescard',
  clubmais: 'brands.clubmais',
  dacasa: 'brands.dacasa',
  carrefour: 'brands.carrefour',
  renner: 'brands.renner',
  urby: 'brands.urby',
  top: 'brands.top',
  pefisa: 'brands.pefisa',
  cliqx: 'brands.cliqx',
  ticket: 'brands.ticket'
}
